import { call, takeEvery, select, put } from 'redux-saga/effects';
import { GO_TO } from '../../constants/service';
import { getHistory } from '../../../services/history';
import { getRootRoute } from '../../../utils/routes';
import { resetFilter } from '../../actions/ui/filter';
import { resetSearch } from '../search';
import { baseURLSelector } from '../../../redux/reducers/app/params';
import { getRoute, setWindowLocationHref } from '../../../utils';

export function* goToWorker(action) {
  if (typeof action.payload !== 'string') {
    // eslint-disable-next-line
    console.error(`"${GO_TO}" action was dispatched with non string payload.`);
    return;
  }

  let pathname = action.payload;

  const history = yield call(getHistory);
  const basename = yield select(baseURLSelector);

  // URI could have basename prefix (in case of HTMLParser.jsx work)
  if (pathname.startsWith(basename)) {
    pathname = pathname.replace(basename, '/').replace(/\/\//g, '/');
  }

  // or it could be correct route string
  const validRoute = getRoute(pathname);

  if (validRoute) {
    if (validRoute === getRootRoute()) {
      // ROOT page side effects
      yield put(resetFilter());
      yield call(resetSearch);
    }

    yield call([history, 'push'], {
      pathname: validRoute,
    });
  } else {
    setWindowLocationHref(pathname);
  }
}

export function* routerWatcher() {
  yield takeEvery(GO_TO, goToWorker);
}
